// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pyVI","title":"styles_title__Z2wd-"};